import * as yup from 'yup';

export const updateProfileSchema = yup.object().shape({
  fullname: yup.string().trim().required('This field is required.'),
  email: yup
    .string()
    .email('This field is required.')
    .required('This field is required.'),
});
